import React, { useState } from 'react';
import { HiMenuAlt3 } from 'react-icons/hi';
import GeneralTab from '../SettingTabsComp/GeneralTab';
import SecurityTab from '../SettingTabsComp/SecurityTab';
import SubscriptionTab from '../SettingTabsComp/SubscriptionTab';
import IntegrationTab from '../SettingTabsComp/IntegrationTab';
import PlatformTab from '../SettingTabsComp/PlatformTab';
import ChatTab from '../SettingTabsComp/ChatTab';
import WebSearchTab from '../SettingTabsComp/WebSearchTab';
import { SettingStyle, TabsWrap } from './SettingSection.styles';

const SettingSection = () => {
  const [activeTab, setActiveTab] = useState(1);
  const [sideActive, setSideActive] = useState(false);

  const handleTabClick = tab => {
    setActiveTab(tab);
    setSideActive(false);
  };

  const tabData = [
    { title: 'Account Settings' },
    {
      name: 'General',
      content: <GeneralTab />,
    },
    {
      name: 'Security & Privacy',
      content: <SecurityTab />,
    },
    {
      name: 'Subscription',
      content: <SubscriptionTab />,
    },
    {
      name: 'Integrations',
      content: <IntegrationTab />,
    },
    { title: 'User Preferences' },
    {
      name: 'Chat',
      content: <GeneralTab />,
    },
    {
      name: 'Web Search',
      content: <SecurityTab />,
    },
    { title: 'Team' },
    {
      name: 'Set up Team',
      content: <p>Team setup and management settings here.</p>,
    },
    {
      name: 'Invites',
      content: <p>Invite new team members and manage invitations here.</p>,
    },
  ];
  // tab content map
  const tabContent = {
    general: <GeneralTab />,
    security: <SecurityTab />,
    subscription: <SubscriptionTab />,
    integrations: <IntegrationTab />,
    chat: <ChatTab />,
    websearch: <WebSearchTab />,
    team: <p>Team setup and management settings here.</p>,
    invites: <p>Invite new team members and manage invitations here.</p>,
  };

  return (
    <SettingStyle>
      <div className="section-header">
        <h1>Settings</h1>
        <button className="btn-menu" onClick={() => setSideActive(prev => !prev)}>
          <HiMenuAlt3 />
        </button>
      </div>
      <TabsWrap>
        {/* LEFT SIDE TABS */}
        <div className={`tab-btns ${sideActive ? 'show' : ''}`}>
          <div className="holder">
            {tabData?.map((elem, ind) => (
              <>
                {elem?.title ? (
                  <span className="subtitle">{elem?.title}</span>
                ) : (
                  <button
                    key={ind}
                    type="button"
                    className={`btn ${activeTab === ind ? 'active' : ''}`}
                    onClick={() => handleTabClick(ind)}>
                    {elem.name}
                  </button>
                )}
              </>
            ))}
          </div>
        </div>

        {/* RIGHT SIDE CONTENT */}
        <div className="tab-content">{tabData[activeTab]?.content}</div>
      </TabsWrap>
    </SettingStyle>
  );
};

export default SettingSection;
